import AlertContainer from './AlertContainer';

const Alert = {
  install(Vue) {
    Vue.component('alert-container', AlertContainer);

    this.container = undefined;

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$alert = {
      setContainer(container) {
        if (Alert.container === undefined) {
          Alert.container = container;
        } else {
          // eslint-disable-next-line no-console
          console.warn('Alert component set more than once.');
        }
      },
      notifySuccess(message) {
        if (Alert.container) {
          Alert.container.addNotification(message, 'success');
        } else {
          throw new Error('You must put a <alert-container /> somewhere in your template.');
        }
      },
      notifyAlert(message) {
        if (Alert.container) {
          Alert.container.addNotification(message, 'error');
        } else {
          throw new Error('You must put a <alert-container /> somewhere in your template.');
        }
      },
    };
  },
};

export default Alert;
